import React from 'react'
import { motion } from 'framer-motion'
import GlobalCursor from '../components/GlobalCursor'

export default function WebsiteDesign() {
  return (
    <div className="min-h-screen relative overflow-hidden bg-black">
      <GlobalCursor />
      <div className="absolute inset-0 stars"></div>
      <div className="absolute inset-0 stars2"></div>

      <div className="relative z-20 px-4 sm:px-6 py-6 sm:py-8 max-w-6xl mx-auto pt-24 sm:pt-32 md:pt-40">
        <motion.h1
          className="text-7xl sm:text-8xl md:text-9xl font-bold text-white mb-8 text-center"
          style={{
            fontFamily: "'Clash Display', 'Arial Black', sans-serif",
            fontWeight: 700,
            letterSpacing: '-0.01em',
            lineHeight: '0.7',
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.8,
            delay: 0.2,
            ease: 'easeOut',
          }}
        >
          website
          <br />
          design
        </motion.h1>

        <div className="text-center text-white max-w-4xl mx-auto">
          <p className="text-xl mb-8">
            Creating modern, responsive websites that deliver exceptional user experiences and drive results.
          </p>
        </div>
      </div>
    </div>
  )
}